/**
 * Settings labels
 * Dynamic mapping from JSON based on current language
 * Uses getLanguage() to determine which locale to use
 */

import svSettings from '../locales/sv/settings.json';
import enSettings from '../locales/en/settings.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

/**
 * Helper function to get the correct locale based on language
 */
const getSettingsLocale = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === 'en' ? enSettings : svSettings;
};

/**
 * Settings labels - dynamically uses current language
 */
export const settingsLabels = (lang?: Language): typeof svSettings => {
  const locale = getSettingsLocale(lang);
  return locale || svSettings;
};


